import actions from "../constants/roHubAccessActions";

export const getRestrictedHubs = (data) => ({
  type: actions.GET_RESTRICTED_HUBS,
  data,
});

export const getRestrictedHubsClear = () => ({
  type: actions.GET_RESTRICTED_HUBS_CLEAR,
});
